import React from 'react';

const Ecommerce = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.26346 8.84216H23.291C23.9886 8.84216 24.5541 9.4077 24.5541 10.1053C24.5541 10.2086 24.5415 10.3115 24.5164 10.4117L21.8369 21.1297C21.4152 22.8166 19.8995 24.0001 18.1606 24.0001H6.39384C4.65497 24.0001 3.13925 22.8166 2.71751 21.1297L0.0380135 10.4117C-0.131185 9.73489 0.280302 9.04908 0.957096 8.87988C1.05729 8.85483 1.16018 8.84216 1.26346 8.84216ZM12.2772 12.6316C11.5796 12.6316 11.0141 13.1972 11.0141 13.8948V18.9474C11.0141 19.6451 11.5796 20.2106 12.2772 20.2106C12.9748 20.2106 13.5404 19.6451 13.5404 18.9474V13.8948C13.5404 13.1972 12.9748 12.6316 12.2772 12.6316ZM5.91686 12.8038C5.24301 12.9844 4.84312 13.677 5.02368 14.3508L6.33139 19.2313C6.51195 19.9052 7.20459 20.3051 7.87844 20.1245C8.55229 19.9439 8.95218 19.2513 8.77163 18.5775L7.46391 13.697C7.28335 13.0231 6.59071 12.6232 5.91686 12.8038ZM18.6376 12.8038C17.9637 12.6232 17.2711 13.0231 17.0905 13.697L15.7828 18.5775C15.6022 19.2513 16.0021 19.9439 16.676 20.1245C17.3498 20.3051 18.0425 19.9052 18.223 19.2313L19.5307 14.3508C19.7113 13.677 19.3114 12.9844 18.6376 12.8038Z"
      fill="#3448FF"
    />
    <g style={{ mixBlendMode: 'multiply' }}>
      <path
        d="M12.2772 3.23627L6.93182 9.65076C6.48521 10.1867 5.68871 10.2591 5.15278 9.81249C4.61685 9.36588 4.54444 8.56938 4.99105 8.03345L11.3068 0.454504C11.8118 -0.151501 12.7426 -0.151501 13.2476 0.454504L19.5634 8.03345C20.01 8.56938 19.9376 9.36588 19.4017 9.81249C18.8657 10.2591 18.0692 10.1867 17.6226 9.65076L12.2772 3.23627Z"
        fill="#FFC85F"
      />
    </g>
  </svg>
);

export default Ecommerce;
